<template>
  <div class="container-fluid">
    <Panel
      :Title="$GetIsAnbohSaz() == 'false' ? 'درخواست وام' : 'درخواست واحد'"
      :Des="
        $GetIsAnbohSaz() == 'false'
          ? 'در این منو میتوانید درخواست وام خود را ثبت نمایید'
          : 'در این منو میتوانید درخواست واحد خود را ثبت نمایید'
      "
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></Panel>
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-hand-holding-usd"></i>
          {{ $GetIsAnbohSaz() == "false" ? "درخواست وام" : "درخواست واحد " }}
        </h6>
      </template>
      <template slot="content">
        <div class="row" style="justify-content: space-evenly">
          <div
            id="Tab1"
            class="col-12 col-md-2 border current bnp-rounded text-right mr-1 pr-3 p-2 hoverHeader"
          >
            <a class="d-block w-100 h-100" id="head1">{{
              $GetIsAnbohSaz() == "false"
                ? " انتخاب نوع وام"
                : "انتخاب نوع واحد"
            }}</a>
          </div>

          <div
            id="Tab2"
            v-if="Object.entries(SelectedVam).length != 0"
            class="col-12 col-md-2 border bnp-rounded text-right mr-1 pr-3 p-2 hoverHeader"
          >
            <a class="d-block w-100 h-100" id="head2"> اطلاعات تکمیلی</a>
          </div>
          <div
            v-else
            class="col-12 col-md-2 border bnp-rounded text-right mr-1 pr-3 p-2"
          >
            <a
              class="d-block w-100 h-100"
              id="head2"
              title="ابتدا نوع وام را مشخص کنید"
            >
              اطلاعات تکمیلی</a
            >
          </div>

          <div
            id="Tab3"
            v-if="vamDetail.Mablaghghest == 0 || vamDetail.MablaghVam == 0"
            class="col-12 col-md-2 border bnp-rounded text-right mr-1 pr-3 p-2"
          >
            <a
              class="d-block w-100 h-100"
              id="head3"
              title="لطفا اطلاعات وام را تکمیل کنید"
            >
              مشخصات ضامنین</a
            >
          </div>
          <div
            v-else
            class="col-12 col-md-2 border bnp-rounded text-right mr-1 pr-3 p-2 hoverHeader"
          >
            <a class="d-block w-100 h-100" id="head3"> مشخصات ضامنین</a>
          </div>

          <div
            id="Tab4"
            class="col-12 col-md-2 border bnp-rounded text-right mr-1 pr-3 p-2 hoverHeader"
          >
            <a class="d-block w-100 h-100" id="head4"> آپلود مدارک</a>
          </div>
          <div
            id="Tab5"
            class="col-md-2 col-12 border bnp-rounded text-right mr-1 pr-3 p-2 hoverHeader"
          >
            <a class="d-block w-100 h-100" id="head5"> تایید نهایی</a>
          </div>
        </div>
        <div class="row mt-3 px-2">
          <div v-if="divToShow == 1" class="col-12 border bnp-rounded">
            <div v-for="(item, key) in Vamha" :key="key" class="row px-3">
              <div class="col-3"></div>
              <div class="col-12 col-md-6 mt-2 p-2">
                <div class="w-100 border bnp-rounded Netpa-Shadow p-2">
                  <div class="row">
                    <div class="col-6 text-right">
                      <span class="text-secondary"
                        >نام
                        {{
                          $GetIsAnbohSaz() == "false" ? "تسهیلات" : "قرارداد"
                        }}:
                      </span>
                      <span class="text-dark font-weight-bold">{{
                        item.desNoe
                      }}</span>
                    </div>

                    <div class="col-6 text-left">
                      <button
                        v-if="SelectedVam.id != item.id"
                        @click="seLectVam(item)"
                        class="btn NetPa-btn btn-primary"
                      >
                        انتخاب
                      </button>
                      <span v-else class="text-success font-weight-bold">
                        انتخاب شده <i class="fas fa-check"></i
                      ></span>
                    </div>
                    <div class="col-12 mt-1 text-right">
                      <span class="text-secondary">{{ item.des }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3"></div>
            </div>
            <div class="row my-3">
              <div class="col-12 col-md-8"></div>
              <div class="col-12 col-md-4">
                <button
                  :disabled="Object.entries(SelectedVam).length === 0"
                  @click="nextPage(2)"
                  class="btn btn-success NetPa-btn"
                >
                  مرحله بعد <i class="fa fa-arrow-left mx-2"></i>
                </button>
              </div>
            </div>
          </div>
          <div v-if="divToShow == 2" class="col-12 border bnp-rounded">
            <div class="row">
              <div class="col-3"></div>
              <div class="col-md-6 col-12 row">
                <div class="col-md-6 py-2 col-12">
                  <label for="MabVam" class="text-secondary">{{
                    $GetIsAnbohSaz() == "false" ? " مبلغ وام" : "مبلغ واحد"
                  }}</label>
                  <input
                    :disabled="
                      ((SelectedVam.bnpCashDBtblNoeId == 66 ||
                        SelectedVam.bnpCashDBtblNoeId == 65) &&
                        $session.get('CustCode') == '843') ||
                      FixInputMabVam == true
                    "
                    type="text"
                    id="MabVam"
                    class="form-control text-left 3ragham"
                    v-model="vamDetail.MablaghVam"
                    @keypress="$ValidNumber($event, 15, false)"
                    @keyup="
                      vamDetail.MablaghVam = $Comma3ragham(vamDetail.MablaghVam)
                    "
                    @blur="
                      $PutCommatoInput();
                      handleMablagh($event);
                      calculateMablaghghest();
                      UpdateZamenPolicy();
                    "
                    dir="ltr"
                  />
                </div>
                <div class="col-md-6 py-2 col-12">
                  <span class="text-secondary text-weight-normal"
                    >تاریخ درخواست</span
                  >
                  <date-picker
                    disabled
                    v-model="vamDetail.NeedData"
                    color="#f38905"
                  ></date-picker>
                  <input
                    type="text"
                    id="NeedData"
                    v-model="vamDetail.NeedData"
                    class="d-none InputText"
                    dir="ltr"
                  />
                </div>
                <div class="col-md-6 py-2 col-12">
                  <label for="ghestNum" class="text-secondary">
                    تعداد قسط</label
                  >
                  <input
                    type="number"
                    id="ghestNum"
                    v-model="vamDetail.TedadGhest"
                    class="form-control text-left"
                    @blur="
                      handleTedad($event);
                      calculateMablaghghest();
                      UpdateZamenPolicy();
                    "
                    maxlength="3"
                    @keypress="$ValidNumber($event, 12, false)"
                    dir="ltr"
                  />
                </div>
                <div class="col-md-6 py-2 col-12">
                  <label for="ghestmab" class="text-secondary">
                    مبلغ قسط
                  </label>
                  <!-- <small v-if="$session.get('CustCode') == '932'" class="text-dark mx-2">( مبلغ زیر بدون محاسبه کارمزد می باشد )</small> -->
                  <input
                    disabled="disabled"
                    type="text"
                    id="ghestmab"
                    v-model="vamDetail.Mablaghghest"
                    class="form-control text-left 3ragham"
                  />
                </div>
                <div class="col-md-6 py-2 col-12">
                  <label class="text-secondary">
                    {{
                      $GetIsAnbohSaz() == "false"
                        ? "نحوه پرداخت وام"
                        : "نحوه دریافت واحد"
                    }}</label
                  >
                  <select v-model="nahvepardakht" class="form-control Pointer">
                    <option
                      value="4014"
                      v-if="$session.get('CustCode') != '793'"
                    >
                      واریز به حساب بانکی
                    </option>
                    <option
                      selected
                      value="4015"
                      v-if="
                        $session.get('CustCode') != '932' &&
                        $session.get('CustCode') != '843' &&
                        $session.get('CustCode') != '259'
                      "
                    >
                      واریز به حساب پس انداز
                    </option>
                  </select>
                </div>
                <div class="col-md-6 py-2 col-12">
                  <span
                    v-if="
                      nahvepardakht == 4015 && $session.get('CustCode') != '932'
                    "
                  >
                    <label class="text-secondary">انتخاب حساب پس انداز </label>
                    <select
                      class="form-control Pointer"
                      v-model="NahveVarizDetail"
                    >
                      <option
                        v-for="item in ListTaahodat"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.desNoe }}
                      </option>
                    </select>
                  </span>
                  <span
                    v-if="
                      nahvepardakht == 4014 && $session.get('CustCode') != '793'
                    "
                  >
                    <label class="text-secondary">انتخاب حساب بانکی </label>
                    <select
                      class="form-control Pointer"
                      v-model="NahveVarizDetail"
                    >
                      <option
                        v-for="item in ListAzaHesab"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.bankName }} -- {{ item.hesabNo }}
                      </option>
                    </select>
                  </span>
                </div>
                <div
                  class="col-md-6 col-12"
                  v-if="$session.get('CustCode') == 793"
                >
                  <label class="text-secondary"> موارد مصرفی وام</label>
                  <select class="form-control" v-model="tblMavaredMasrafiVamId">
                    <option :value="0">
                      -- یکی از موارد مصرف را انتخاب کنید --
                    </option>
                    <option
                      v-for="(item, key) in ListMavaredMasrafVam"
                      :key="key"
                      :value="item.id"
                    >
                      {{ item.onvanMavaredMasrafVam }}
                    </option>
                  </select>
                </div>
                <div
                  v-if="
                    $session.get('CustCode') == '932' &&
                    SelectedVam.bnpCashDBtblNoeId == 2698162
                  "
                  class="col-md-3 py-2 col-12"
                >
                  <label class="text-secondary"> مدت سپرده ( ماه ) </label>
                  <input
                    class="form-control text-center required"
                    type="number"
                    maxlength="3"
                    v-model="vamDetail.SepordeTime"
                  />
                </div>
              </div>
              <div class="col-3"></div>
            </div>
            <div class="row my-3">
              <div class="col-md-8 col-12"></div>
              <div class="col-md-4 col-12">
                <button
                  @click="nextPage(1)"
                  class="btn btn-warning NetPa-btn d-inline px-4"
                >
                  <i class="fa fa-arrow-right mx-2"></i>مرحله قبل
                </button>
                <button
                  :disabled="
                    isValidTedad == true && isValidMablaghVam == true
                      ? false
                      : 'disabled'
                  "
                  @click="nextPage(3)"
                  class="btn btn-success d-inline NetPa-btn px-4"
                >
                  مرحله بعد <i class="fa fa-arrow-left mx-2"></i>
                </button>
              </div>
              <div class="col-2"></div>
            </div>
            <div class="row">
              <div class="col-md-4 col-12 px-2">
                <ul class="alert alert-secondary pr-5">
                  <li v-if="SelectedVam.minMablagh > 0" class="text-warning h6">
                    <small>
                      حداقل مبلغ قابل درخواست
                      {{ this.$Comma3ragham(SelectedVam.minMablagh) }}
                      {{ $GetVahedPool() }}
                    </small>
                  </li>
                  <li v-if="SelectedVam.maxMablagh > 0" class="text-warning h6">
                    <small>
                      حداکثر مبلغ قابل درخواست
                      {{
                        $session.get("CustCode") == "932"
                          ? this.$Comma3ragham(
                              Math.round(SelectedVam.maxMablagh),
                            )
                          : this.$Comma3ragham(SelectedVam.maxMablagh)
                      }}
                      {{ $GetVahedPool() }}
                    </small>
                  </li>
                  <li v-if="SelectedVam.minTedad > 0" class="text-warning h6">
                    <small>
                      حداقل تعداد قسط درخواستی
                      {{ this.$Comma3ragham(SelectedVam.minTedad) }}
                    </small>
                  </li>
                  <li v-if="SelectedVam.maxTedad > 0" class="text-warning h6">
                    <small>
                      حداکثر تعداد قسط درخواستی
                      {{ this.$Comma3ragham(SelectedVam.maxTedad) }}
                    </small>
                  </li>
                </ul>
              </div>
              <div v-if="lines" class="col-md-4 col-12 px-2">
                <ul class="alert alert-info pr-5">
                  <li class="mt-2 text-warning">
                    <p
                      class="text-dark font-weight-bold"
                      v-for="line in lines"
                      :key="line"
                    >
                      {{ line }}
                    </p>
                  </li>
                </ul>
              </div>
              <div v-if="SelectedVam.isUpload" class="col-md-4 col-12 px-2">
                <div class="alert alert-info pr-2 text-dark font-weight-bold">
                  شرایط آپلود مدارک
                  {{ $GetIsAnbohSaz() == "false" ? "تسهیلات" : "قرارداد" }}
                  <br />
                  <ul>
                    <li class="mt-2 text-warning">
                      <p
                        class="text-dark"
                        v-for="line in linesattachment"
                        :key="line"
                      >
                        {{ line }}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div v-if="divToShow == 3" class="col-12 border bnp-rounded">
            <div class="row">
              <div class="col-2"></div>
              <div class="col-12 col-md-8">
                <div
                  v-for="(item, key) in ListNoePolicyFilter.tedad"
                  :key="key"
                  class="col-12 row my-3 mx-auto"
                >
                  <div
                    class="col-2"
                    v-if="$session.get('CustCode') != 932"
                  ></div>
                  <div
                    :class="
                      $session.get('CustCode') == 932
                        ? 'col-12 col-md-5'
                        : 'col-12 col-md-6 '
                    "
                  >
                    <small>{{ " کد ملی ضامن " }} {{ key + 1 }}</small>
                    <input
                      type="number"
                      class="form-control text-center mt-1"
                      dir="ltr"
                      v-model="ListCodeMeli[key]"
                    />
                  </div>
                  <div
                    class="col-12 col-md-5"
                    v-if="$session.get('CustCode') == 932"
                  >
                    <small>{{ "رمز کسر اقساط ضامن" }} {{ key + 1 }}</small>
                    <input
                      type="number"
                      class="form-control required mt-1 text-center"
                      v-model="ListRamzKasrAghsat[key]"
                    />
                    <span class="text-danger"
                      >رمز کسر اقساط شامل 13 رقم میباشد که توسط سازمان تامین
                      اجتماعی پیامک میگردد</span
                    >
                  </div>
                  <div class="col-2 col-md-2">
                    <button
                      class="btn btn-success mt-4"
                      @click="GetZament(key)"
                    >
                      استعلام
                    </button>
                    <button
                      class="d-none"
                      id="ZamenModal"
                      data-toggle="modal"
                      data-target="#Modal-Orange"
                    >
                      modal
                    </button>
                  </div>
                  <div
                    class="col-2"
                    v-if="$session.get('CustCode') != 932"
                  ></div>
                </div>

                <div
                  v-for="(item, index) in ListZamen"
                  :key="index"
                  class="col-12 row my-3 mx-auto"
                >
                  <div
                    class="col-10 my-2 border border-success rounded p-2 mx-auto"
                    :class="$session.get('CustCode') != 932 ? 'col-md-8' : ''"
                  >
                    <div class="w-100">
                      <span class="text-secondary"
                        >نام ضامن {{ index + 1 }} :</span
                      >
                      <span class="text-dark">
                        {{ item.NameFamily }}
                      </span>
                      <span class="float-left"
                        ><a
                          href="javascript:;"
                          class="mr-2 badge"
                          @click="OnDelete(item.CodeMeli)"
                        >
                          <i
                            class="fa fa-trash-alt text-secondary hover-dange"
                          ></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  class="alert alert-warning px-3 mt-3 text-center"
                  v-if="ListNoePolicyFilter.tedad == 0"
                >
                  {{
                    "این نوع وام نیازی به ضامن ندارد ، بر روی دکمه مرحله بعدی کلیک کنید"
                  }}
                </div>
              </div>
              <div class="col-2"></div>
            </div>
            <div class="row my-3">
              <div class="col-12 col-md-8"></div>
              <div class="col-12 col-md-4">
                <button
                  @click="nextPage(2)"
                  class="btn btn-warning NetPa-btn d-inline px-4"
                >
                  <i class="fa fa-arrow-right mx-2"></i>مرحله قبل
                </button>
                <button
                  :disabled="
                    vamDetail.Mablaghghest == 0 || vamDetail.MablaghVam == 0
                  "
                  @click="nextPage(4)"
                  class="btn btn-success my-2 d-inline NetPa-btn px-4"
                >
                  مرحله بعد<i class="fa fa-arrow-left mx-2"></i>
                </button>
              </div>
            </div>
          </div>
          <div v-if="divToShow == 4" class="col-12 border bnp-rounded">
            <div v-if="SelectedVam.isUpload" class="row">
              <div class="col-md-3"></div>
              <div class="col-md-6 col-12 p-4 row">
                <div class="col-12">
                  <div
                    v-if="$cookies.isKey('DownloadForm')"
                    class="w-100 p-4 row yellowback mb-2 text-center"
                    style="height: 10vh"
                  >
                    <h6>
                      برای دانلود فرم درخواست وام
                      <a
                        :href="$cookies.get('DownloadForm')"
                        download="فرم درخواست وام"
                        ><sapn class="badge badge-success">اینجا</sapn></a
                      >
                      کلیک کنید.
                    </h6>
                  </div>
                </div>
                <div class="col-12">
                  <div
                    class="w-100 pt-4 text-center alert-info bnp-rounded"
                    style="height: 25vh"
                  >
                    <div class="">
                      <div class="text-center">
                        <span>
                          <i
                            class="fas fa-file text-primary mt-2"
                            style="font-size: 50px !important"
                          ></i>
                        </span>
                      </div>
                      <div class="text-center mt-3" v-if="attachment">
                        <div class="" v-if="$session.get('CustCode') != '932'">
                          <div>
                            <span class="text-secondary my-3">نام فایل:</span>
                            <span class="text-dark">{{ attachment.name }}</span>
                          </div>
                          <div>
                            <span class="text-secondary">حجم فایل:</span>
                            <span class="text-dark">
                              KB {{ attachment.size / 1000 }}
                            </span>
                          </div>
                        </div>
                        <div class="" v-else>
                          <div class="font-weight-normal">فایل بارگذاری شد</div>
                        </div>
                      </div>
                    </div>
                    <div class="">
                      <input
                        v-if="
                          $session.get('CustCode') == '932' ||
                          $session.get('CustCode') == '8002'
                        "
                        type="file"
                        id="attachmentUploader"
                        multiple="multiple"
                        @change="changeattach($event)"
                        class="d-none"
                        accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                      />
                      <input
                        v-else
                        type="file"
                        id="attachmentUploader"
                        @change="changeattach($event)"
                        class="d-none"
                        accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                      />
                      <button
                        class="btn btn-primary m-4 Netpa-btn"
                        @click="clickUploader"
                        style="margin: auto"
                      >
                        بارگذاری فایل
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="col-12 mt-4 text-center alert alert-secondary bnp-rounded"
                  v-if="$session.get('CustCode') == '932'"
                >
                  <span>کد کسر اقساط خود را وارد نمایید</span>
                  <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                      <input
                        type="number"
                        class="form-control text-center mt-2"
                        v-model="codeKasrAghsat"
                      />
                      <span class="text-danger"
                        >رمز کسر اقساط شامل 13 رقم میباشد که توسط سازمان تامین
                        اجتماعی پیامک میگردد</span
                      >
                    </div>
                    <div class="col-md-2"></div>
                  </div>
                </div>
              </div>
              <div class="col-md-3"></div>
            </div>
            <div class="row mb-2 px-2">
              <div
                v-if="SelectedVam.isUpload"
                class="col-12 alert-secondary p-2"
              >
                شرایط آپلود مدارک
                {{ $GetIsAnbohSaz() == "false" ? "تسهیلات" : "قرارداد" }}
                <br />
                <ul>
                  <li class="mt-2 text-warning">
                    <p
                      class="text-dark"
                      v-for="line in linesattachment"
                      :key="line"
                    >
                      {{ line }}
                    </p>
                  </li>
                </ul>
              </div>
              <div v-else class="col-12">
                <ul>
                  <li class="text-info h6 mt-2">
                    <p>
                      {{
                        $GetIsAnbohSaz() == "false"
                          ? "مدارکی برای این نوع تسهیلات برای آپلود نیاز نیست"
                          : "مدارکی برای این نوع قرارداد برای آپلود نیاز نیست"
                      }}
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div class="row my-3">
              <div class="col-12 col-md-8"></div>
              <div class="col-12 col-md-4">
                <button
                  @click="nextPage(3)"
                  class="btn btn-warning NetPa-btn d-inline px-4"
                >
                  <i class="fa fa-arrow-right mx-2"></i>مرحله قبل
                </button>

                <button
                  v-if="SelectedVam.isUpload && attachment != null"
                  @click="nextPage(5)"
                  class="btn btn-success my-2 NetPa-btn d-inline px-4"
                >
                  مرحله بعد <i class="fa fa-arrow-left mx-2"></i>
                </button>
                <button
                  v-else-if="!SelectedVam.isUpload"
                  @click="nextPage(5)"
                  class="btn btn-success my-2 NetPa-btn d-inline px-4"
                >
                  مرحله بعد<i class="fa fa-arrow-left mx-2"></i>
                </button>
                <button
                  v-else
                  disabled
                  class="btn btn-success my-2 NetPa-btn d-inline px-4"
                >
                  مرحله بعد<i class="fa fa-arrow-left mx-2"></i>
                </button>
              </div>
            </div>
          </div>

          <div v-if="divToShow == 5" class="col-12 border bnp-rounded">
            <div class="w-100 p-2">
              <h4 style="font-size: 15px" class="font-weight-bold">
                تایید نهایی درخواست
              </h4>
              <hr />
            </div>
            <div
              class="row border-right border-primary my-1 mx-3"
              style="border-right: 3px solid #007bff !important"
            >
              <div class="col-12 m-2 border-bottom">
                <h6>مشخصات وام</h6>
              </div>
              <div class="col-md-6 col-12 my-1">
                <span class="text-secondary font-weight-bold">
                  نام
                  {{ $GetIsAnbohSaz() == "false" ? "تسهیلات" : "قرارداد" }}
                  درخواستی:</span
                >
                <span class="text-dark"> {{ SelectedVam.desNoe }} </span>
              </div>
              <div class="col-md-6 col-12 my-1">
                <span class="text-secondary font-weight-bold">
                  مبلغ درخواستی :</span
                >
                <span class="text-dark">
                  {{ $Comma3ragham(vamDetail.MablaghVam) }}
                  {{ $GetVahedPool() }}</span
                >
              </div>
              <div
                class="col-md-6 col-12 my-1"
                v-if="this.$session.get('CustCode') != 9"
              >
                <span class="text-secondary font-weight-bold">
                  مبلغ هر قسط :</span
                >
                <span class="text-dark">
                  {{ $Comma3ragham(vamDetail.Mablaghghest) }}
                  {{ $GetVahedPool() }}</span
                >
              </div>
              <div class="col-md-6 col-12 my-1">
                <span class="text-secondary font-weight-bold">
                  تعداد قسط :</span
                >
                <span class="text-dark"> {{ vamDetail.TedadGhest }} </span>
              </div>
              <div class="col-md-6 col-12 my-1">
                <span class="text-secondary font-weight-bold">
                  تاریخ درخواست وام:</span
                >
                <span class="text-dark"> {{ vamDetail.NeedData }} </span>
              </div>
            </div>
            <!-- <div class="w-100 border my-3 border-success">
              {{ ListZamen }}
            </div> -->
            <div
              class="row border-right border-success mt-3 mx-3"
              style="border-right: 3px solid #28a745 !important"
            >
              <div class="col-12 m-2 border-bottom">
                <h6>مشخصات ضامنین</h6>
              </div>
              <div class="col-12 border rounded m-2" id="ZamenInformation">
                <div v-for="(item, key) in ListZamen" :key="key" class="row">
                  <div class="col-12 m-2">
                    <span class="font-weight-bold font-weight-bold"
                      >مشخصات ضامن {{ key + 1 }}</span
                    >
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary"> نام نام خانوادگی: </span>
                    <span>{{ item.NameFamily }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary font-weight-bold">
                      کدملی:
                    </span>
                    <span>{{ item.CodeMeli }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary font-weight-bold">
                      نام پدر:
                    </span>
                    <span>{{ item.Pedar }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary font-weight-bold">
                      شماره تماس:
                    </span>
                    <span>{{ item.Tel }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary font-weight-bold">
                      شماره همراه:
                    </span>
                    <span>{{ item.Mobile }}</span>
                  </div>
                  <div class="colmd-6 col-12">
                    <span class="text-secondary font-weight-bold"> آدرس: </span>
                    <span>{{ item.Adres }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row border-right border-danger mt-3 mx-3"
              style="border-right: 3px solid #f5a002 !important"
            >
              <div class="col-12 m-2 border-bottom">
                <h6>مشخصات فایلها</h6>
              </div>

              <div v-if="attachment" class="col-12">
                <div
                  class="row"
                  v-if="
                    $session.get('CustCode') != '932' &&
                    $session.get('CustCode') != '8002'
                  "
                >
                  <div class="col-md-6 col-12">
                    <span class="text-secondary">نام فایل: </span>
                    <span>{{ attachment.name }}</span>
                  </div>
                  <div class="col-md-6 col-12">
                    <span class="text-secondary">حجم فایل: </span>
                    <span>{{ attachment.size / 1000000 }} Mb</span>
                  </div>
                </div>
                <div class="" v-else>
                  <div class="">چند فایل بارگذاری شده</div>
                </div>
              </div>
            </div>
            <div
              class="row border-right border-warning mt-5 mx-3"
              style="border-right: 3px solid #dc3545 !important"
              v-if="
                $session.get('CustCode') == '932' &&
                this.SelectedVam.bnpCashDBtblNoeId == 363490
              "
            >
              <div class="col-12">
                <!-- #1083674 برای تسهیلات بدون سپرده پیغام مجزا  -->
                <h6 class="text-danger font-weight-bold">
                  <input
                    type="checkbox"
                    v-model="CheckBedoneSeporder932"
                    style="width: 20px !important; height: 20px !important"
                  />
                  ثبت نام مجدد بابت تسهیلات بدون سپرده، منوط به گذشت سه ماه از
                  آخرین قسط پرداخت تسهیلات قبلی می باشد، در صورت ثبت درخواست
                  زودتر از موعد، مدارک مربوطه بایگانی و پس از زمان ذکرشده واریز
                  می گردد.
                </h6>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-md-8 col-12"></div>
              <div class="col-md-4 col-12">
                <button
                  @click="nextPage(4)"
                  class="btn btn-warning NetPa-btn d-inline px-4"
                >
                  <i class="fa fa-arrow-right mx-2"></i>مرحله قبل
                </button>
                <button
                  @click="Submit"
                  class="btn btn-success NetPa-btn d-inline px-4"
                >
                  <i class="fa fa-check mx-2"></i>ثبت نهایی
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </net-pa-card>
    <button
      class="btn btn-outline-secondary btn-sm m-1 d-none"
      id="openModal"
      type="button"
      data-toggle="modal"
      data-target="#Modal-light"
    >
      <span>تغــییر وضعیت</span>
    </button>
    <ModalCustom>
      <template v-slot:ContentModalLight>
        <div class="">
          <div class="alert alert-info text-center">
            اطلاعات ضامن خود را وارد نمایید و اطلاعات خواسته شده را تکمیل
            فرمایید .
          </div>
          <div class="row" id="NewZamenForm">
            <div class="col-12 col-md-4 p-2">
              <input
                type="text"
                placeholder="نام و نام خانوادگی"
                class="form-control text-center required"
                v-model="ZamenToInsert.NameFamily"
              />
            </div>
            <div
              class="col-12 col-md-4 p-2"
              v-if="
                $session.get('CustCode') != '932' &&
                $session.get('CustCode') != '8002'
              "
            >
              <input
                type="text"
                placeholder="نام پدر"
                class="form-control required"
                v-model="ZamenToInsert.Pedar"
              />
            </div>
            <div
              class="col-12 col-md-4 p-2"
              v-if="
                $session.get('CustCode') != '932' &&
                $session.get('CustCode') != '8002'
              "
            >
              <input
                type="text"
                placeholder="شغل"
                class="form-control required"
                v-model="ZamenToInsert.Job"
              />
            </div>
            <div
              class="col-12 col-md-4 p-2"
              v-if="
                $session.get('CustCode') != '932' &&
                $session.get('CustCode') != '8002'
              "
            >
              <input
                type="number"
                placeholder="تلفن ثابت"
                class="form-control text-left required"
                v-model="ZamenToInsert.Tel"
              />
            </div>
            <div class="col-12 col-md-4 p-2">
              <input
                type="number"
                placeholder="تلفن همراه"
                class="form-control text-center required"
                v-model="ZamenToInsert.Mobile"
              />
            </div>
            <div class="col-12 col-md-4 p-2">
              <input
                type="number"
                placeholder="شماره پرسنلی | مستمری"
                class="form-control text-center required"
                v-model="ZamenToInsert.PerNo"
              />
            </div>
            <div
              class="col-12 p-2 col-md-12"
              v-if="
                $session.get('CustCode') != '932' &&
                $session.get('CustCode') != '8002'
              "
            >
              <textarea
                type="text"
                class="form-control"
                v-model="ZamenToInsert.Adres"
                placeholder="آدرس"
              >
              </textarea>
            </div>
            <div
              class="col-12 p-2 text-right"
              v-if="
                $session.get('CustCode') == '932' ||
                $session.get('CustCode') == '8002'
              "
            >
              <input
                type="file"
                @change="changefile($event)"
                class="d-none required"
                id="Uploader"
                accept=".gif,.jpg,.jpeg,.png,.pdf"
              />
              <button
                class="btn btn-primary m-2 Netpa-btn"
                @click="clickUploaderZamen"
                style="margin: auto"
              >
                بارگذاری مدارک ضامن
              </button>
              <!-- <uploader :whithName="false" :Idu="'FormFile'" :key="keyrender" :base64="null" :TableName="'wwwtblNeedVam'" @Done="GetFile" :attachId="null" :address="null" :grp="181070513" :title="'فایل خود را بارگذاری کنید'" :MasterId="$session.get('CustCode')"></uploader> -->
              <span class="text-danger" v-if="!fileinfo.name"
                >فایل مربوط به ضامن بارگذاری نشده</span
              >
              <span v-if="fileinfo.name"
                ><b>نام فایل :</b> {{ fileinfo.name }}</span
              >&nbsp;&nbsp;
              <span v-if="fileinfo.name"
                ><b> اندازه فایل : </b> KB {{ fileinfo.size / 1000 }}
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <button class="btn btn-success NetPa-btn w-100" @click="NewZamen">
                ثبت ضامن
              </button>
            </div>
            <div class="col-md-4"></div>
          </div>
        </div>
      </template>
    </ModalCustom>
    <loading v-if="LOADING"></loading>
  </div>
</template>

<script>
import Panel from "../Tools/NetPa/Panel.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import ModalCustom from "../Tools/ModalCustom.vue";
import uploader from "../../components/CmpNetPa/Componenets/NetpaUploader.vue";
import JSZip from "jszip";
import loading from "../Tools/NetPa/Loading.vue";
export default {
  data() {
    return {
      CheckBedoneSeporder932: false,
      LOADING: false,
      codeKasrAghsat: null,
      ListNoePolicy: null,
      ListNoePolicyFilter: null,
      lines: [],
      linesattachment: [],
      SelectedVam: {},
      // vamDetail: {
      //     id: 0,
      //     des: '',
      //     desNoe: '' ,
      //     desUpload: '',
      //     isActive: true,
      //     minMablagh: 0,
      //     maxMablagh: 0,
      //     isformula: false,
      //     minTedad: 1,
      //     maxTedad: 36,
      //     isUpload: false,
      //     isSafteElectronic: false,
      //     NeedData:''
      // },
      nahvepardakht: this.$session.get("CustCode") != "832" ? 4015 : 4014,
      NahveVarizDetail: null,
      DataAxiosTaahodat: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosAzaHesab: {
        ArryfildValue: "",
        Method: "Get",
        Action: "AzaHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      ListTaahodat: [],
      ListAzaHesab: [],
      vamDetail: {
        Mablaghghest: 0,
        TedadGhest: 24,
        MablaghVam: 0,
        NeedData: "",
        SepordeTime: null,
      },
      isValidMablaghVam: false,
      isValidTedad: false,
      divToShow: 1,
      Vamha: [],
      DataAxiosGetNoeVam: {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/SelTozihatRequest",
        Token: this.$session.get("TokenNetPa"),
      },
      DataActionVamCondition: {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/VamCondition",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosZamenPolicy: {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/GetZamenPolicyOnline",
        Token: this.$session.get("TokenNetPa"),
      },
      ListCodeMeli: [],
      ListRamzKasrAghsat: [],
      ListZamen: [],
      attachment: null,
      ZamenToInsert: {},
      ListZamenToInsert: [],
      fileinfo: {},
      uploadImageName: "",
      base64: null,
      imageSize: 0,
      fileFormat: "",
      ListMavaredMasrafVam: [],
      tblMavaredMasrafiVamId: 0,
      FixInputMabVam: false,
    };
  },
  components: { Panel, NetPaCard, ModalCustom, uploader, loading },
  mounted() {
    this.nahvepardakht = this.$session.get("CustCode") != "832" ? 4015 : 4014;
    this.vamDetail.NeedData = this.$GetJalaliDate();
    this.GetNoeVam();
    //#region Sandogh Oliya 793
    if (
      this.$session.get("CustCode") == 793 ||
      this.$session.get("CustCode") == 8002
    ) {
      this.GetMavaredMasrafi();
    }
    //#endregion
  },
  methods: {
    Submit() {
      if (this.$session.get("CustCode") == "932") {
        if (
          this.CheckBedoneSeporder932 == false &&
          this.SelectedVam.bnpCashDBtblNoeId == 363490
        ) {
          this.$mySweetDefault(
            "عدم پذیرفتن شرایط",
            "برای درخواست این نوع وام باید شرایط ثبت نام را بپذیرید",
            "info",
            3000,
          );
        } else {
          this.$SweetQustion(
            "تایید نهایی درخواست",
            "در صورت ثبت درخواست و بارگذاري مدارك پس از 72 ساعت اداری به قسمت تسهيلات-پيگيري درخواست وام ورود كرده و از وضعيت ارسال مدارك خويش مطلع شويد",
            "info",
            "تایید نهایی",
            "انصراف",
            null,
            this.FinalSubmit,
            this.cancel,
          );
        }
      } else {
        this.FinalSubmit();
      }
    },
    FinalSubmit() {
      if (!this.$ValidForm("ZamenInformation")) {
        return;
      }
      this.LOADING = true;
      var formdata = new FormData();
      // console.log('😎 ~ FinalSubmit ~ this.ListZamen:', this.ListZamen)
      this.vamDetail.MablaghVam = this.vamDetail.MablaghVam.replaceAll(",", "");
      formdata.append("MablaghEftetahHesab", this.$GetMablaghEftetahHesab());
      formdata.append(
        "ramzKasrAghsat",
        this.codeKasrAghsat == null ? "" : this.codeKasrAghsat,
      );
      formdata.append("NahveVarizDetail", this.NahveVarizDetail);
      formdata.append("WwwtblcomboIdNahveVarizGrp7", this.nahvepardakht);
      formdata.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formdata.append("RequestTarix", this.$store.state.JalaliDate);
      formdata.append("Mablagh", this.vamDetail.MablaghVam);
      formdata.append("MablaghTavanaiePardakht", this.vamDetail.MablaghVam);
      formdata.append("TedadGhest", this.vamDetail.TedadGhest);
      formdata.append("NeedTarix", this.vamDetail.NeedData);
      formdata.append(
        "CodeMeliZamenAsli",
        typeof this.ListCodeMeli[0] == "undefined" ? "" : this.ListCodeMeli[0],
      );
      formdata.append(
        "CodeMeliZamenFarei",
        this.ListCodeMeli != null && this.ListCodeMeli.length > 1
          ? this.ListCodeMeli[1]
          : "",
      );
      formdata.append(
        "NameFamilyZamenAsli",
        this.ListZamen.length == 0 ? "" : this.ListZamen[0].NameFamily,
      );
      formdata.append(
        "CodeMeliMoaref",
        this.ListCodeMeli != null && this.ListCodeMeli.length > 2
          ? this.ListCodeMeli[2]
          : "",
      );
      formdata.append(
        "PedarZamenAsli",
        this.ListZamen.length == 0 ? "" : this.ListZamen[0].Pedar,
      );
      formdata.append(
        "TelZamenAsli",
        this.ListZamen.length == 0 ? "" : this.ListZamen[0].Tel,
      );
      formdata.append(
        "MobileZamenAsli",
        this.ListZamen.length == 0 ? "" : this.ListZamen[0].Mobile,
      );
      formdata.append(
        "AdresZamenAsli",
        this.ListZamen.length == 0 ? "" : this.ListZamen[0].Adres,
      );
      formdata.append(
        "MobileZamenFarei",
        this.ListZamen.length != 0 && this.ListZamen.length > 1
          ? this.ListZamen[1].Mobile
          : "",
      );
      formdata.append(
        "AdresZamenFarei",
        this.ListZamen.length != 0 && this.ListZamen.length > 1
          ? this.ListZamen[1].Adres
          : "",
      );
      formdata.append(
        "TelZamenFarei",
        this.ListZamen.length != 0 && this.ListZamen.length > 1
          ? this.ListZamen[1].Tel
          : "",
      );
      formdata.append(
        "PedarZamenFarei",
        this.ListZamen.length != 0 && this.ListZamen.length > 1
          ? this.ListZamen[1].Pedar
          : "",
      );
      formdata.append(
        "NameFamilyZamenFarei",
        this.ListZamen.length != 0 && this.ListZamen.length > 1
          ? this.ListZamen[1].NameFamily
          : "",
      );
      formdata.append(
        "ShoghlZamenAsli",
        this.ListZamen.length == 0 ? "" : this.ListZamen[0].Job,
      );
      formdata.append(
        "ShoghlZamenFarei",
        this.ListZamen.length != 0 && this.ListZamen.length > 1
          ? this.ListZamen[1].Job
          : "",
      );
      formdata.append(
        "ShoglMoaref",
        this.ListZamen.length != 0 && this.ListZamen.length > 2
          ? this.ListZamen[2].Job
          : "",
      );
      formdata.append(
        "AdresMoaref",
        this.ListZamen.length != 0 && this.ListZamen.length > 2
          ? this.ListZamen[2].Adres
          : "",
      );
      formdata.append(
        "MobileMoaref",
        this.ListZamen.length != 0 && this.ListZamen.length > 2
          ? this.ListZamen[2].Mobile
          : "",
      );
      formdata.append(
        "TellMoaref",
        this.ListZamen.length != 0 && this.ListZamen.length > 2
          ? this.ListZamen[2].Tel
          : "",
      );
      formdata.append(
        "PedarMoaref",
        this.ListZamen.length != 0 && this.ListZamen.length > 2
          ? this.ListZamen[2].Pedar
          : "",
      );
      formdata.append(
        "NameFamiliMoaref",
        this.ListZamen.length != 0 && this.ListZamen.length > 2
          ? this.ListZamen[2].NameFamily
          : "",
      );
      formdata.append(
        "AzaIdMoaref",
        this.ListZamen.length != 0 && this.ListZamen.length > 2
          ? this.ListZamen[2].Id
          : "",
      );
      formdata.append(
        "AzaIdZamenFarei",
        this.ListZamen.length != 0 && this.ListZamen.length > 1
          ? this.ListZamen[1].Id
          : "",
      );
      formdata.append(
        "AzaIdZamen",
        this.ListZamen.length == 0 ? "" : this.ListZamen[0].Id,
      );
      formdata.append("IsTaeidVam", 0);
      formdata.append("SepordeTime", this.vamDetail.SepordeTime);
      formdata.append("wwwtblNoeId", this.SelectedVam.id);

      // 932
      formdata.append(
        "CodeKasreAghsatZamenAsli",
        typeof this.ListZamen[0] == "undefined"
          ? ""
          : this.ListZamen[0].RamzKasrAghsatZamen,
      );
      formdata.append(
        "CodeKasreAghsatZamenFari",
        typeof this.ListZamen[1] == "undefined"
          ? ""
          : this.ListZamen[1].RamzKasrAghsatZamen,
      );
      formdata.append(
        "CodeKasreAghsatMoaref",
        typeof this.ListZamen[2] == "undefined"
          ? ""
          : this.ListZamen[2].RamzKasrAghsatZamen,
      );

      // 793
      formdata.append("tblMavaredMasrafiVamId", this.tblMavaredMasrafiVamId);

      if (this.attachment) {
        formdata.append("file", this.attachment);
      }
      if (this.ListZamen.length > 0) {
        if (this.ListNoePolicyFilter.isOzv == false) {
          formdata.append(
            "PerNoZamen",
            this.ListZamen[0] ? this.ListZamen[0].PerNo : null,
          );
          formdata.append(
            "PerNoZamenFarei",
            this.ListZamen[1] ? this.ListZamen[1].PerNo : null,
          );
          formdata.append(
            "PerNoMoaref",
            this.ListZamen[2] ? this.ListZamen[2].PerNo : null,
          );
        } else {
          formdata.append("PerNoZamen", null);
          formdata.append("PerNoZamenFarei", null);
          formdata.append("PerNoMoaref", null);
        }
      }

      var DataAxiosSubmit = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "InsNewVam",
        Token: this.$session.get("TokenNetPa"),
      };

      this.$PostFormData(DataAxiosSubmit)
        .then((data) => {
          this.LOADING = false;
          if (data.success == "SUCCESS") {
            this.needVamId = data.needVamId;
            //اگر needVamId پر بود فایل هارو بفرستیم
            if (this.$session.get("CustCode") == 868) {
              if (
                this.FileHokm868 != null &&
                this.FileZamenanat868 != null &&
                this.FileGhardad868 != null
              ) {
                var formdataAtach = new FormData();
                formdataAtach.append("needVamId", this.needVamId);
                formdataAtach.append("FileHokm868", this.FileHokm868);
                formdataAtach.append("FileZamenanat868", this.FileZamenanat868);
                formdataAtach.append("FileGhardad868", this.FileGhardad868);
                var axios = {
                  Method: "POST",
                  Action: "InsNewVam/Atachment868",
                  ArryfildValue: formdataAtach,
                  Token: this.$session.get("TokenNetPa"),
                };
                this.$PostFormData(axios).then((res) => {});
              } else {
                this.$mySweetDefaultTost(
                  "خطا",
                  "لطفا تمامی فایل های خواسته شده را آپلود نمایید ",
                  "warning",
                  2000,
                );
              }
            }
            if (
              this.$session.get("CustCode") == 932 ||
              this.$session.get("CustCode") == 8002
            ) {
              let DataAxiosUpload = {
                ArryfildValue: "",
                Method: "Post",
                Action: "InsNewVam/UploadZipAtachment",
                Token: this.$session.get("TokenNetPa"),
              };
              var formdata = new FormData();
              formdata.append("Image", JSON.stringify(this.base64));
              formdata.append("IdRequest", this.needVamId);
              DataAxiosUpload.ArryfildValue = formdata;
              this.$PostFormData(DataAxiosUpload).then((data) => {
                if (data.status == "Ok") {
                  return;
                } else {
                  return;
                }
              });
            }
            this.ListZamenToInsert.forEach((element) => {
              if (element.file.size) {
                //Save File Attach Zamen
                let DataAxiosUpload = {
                  ArryfildValue: "",
                  Method: "Post",
                  Action: "EftetahHesab/SaveAttachmentToDb",
                  Token: "",
                };
                var formdata = new FormData();
                formdata.append("IdEftetah", this.needVamId);
                formdata.append("Image", element.file);
                formdata.append("TableName", "wwwtblNeedVam");
                formdata.append("wwwtblcomboidgrp328", 181070523); //181070523 آیدی اتچ ضامنین
                DataAxiosUpload.ArryfildValue = formdata;
                this.$PostFormData(DataAxiosUpload).then((data) => {});
              }
            });

            this.$mySweetDefault(
              "عملیات موفق",
              "درخواست وام شما با کد رهگیری " +
                data.codeRahgiri +
                " در سیستم ثبت شد.",
              "success",
              2500,
            );
            this.$router.push("loanFollowup");
          } else {
            this.needVamId = 0;
            this.$mySweetDefault(
              "عملیات ناموفق",
              "درخواست شما در سیستم ثبت نشد." +
                "لطفا در روزهای بعدی اقدام به ثبت درخواست کنید",
              "warning",
              2500,
            );
          }
        })
        .catch((error) => {
          this.LOADING = false;
          this.$mySweetDefault(
            "عملیات ناموفق",
            "مشکلی بوجود آمده است. دوباره تلاش کنید",
            "error",
            2500,
          );
          this.needVamId = 0;
          console.warn(error);
        });
    },
    OnDelete(data) {
      for (let index = 0; index < this.ListZamen.length; index++) {
        if (this.ListZamen[index].CodeMeli == data) {
          this.ListZamen.splice(index, 1);
        }
      }
    },
    GetZament(number) {
      this.fileinfo = {};
      // console.log('number',number);
      if (
        this.$session.get("UserInfoNetPa").codeMeli.trim() ==
        this.ListCodeMeli[number]
      ) {
        this.$mySweetDefault(
          "خطا",
          "شما کد ملی خود را وارد کرده اید",
          "error",
          2000,
        );
        this.ListRamzKasrAghsat[number] = "";
        return;
      }
      if (
        this.$session.get("CustCode") == 932 &&
        (this.ListRamzKasrAghsat[number] == undefined ||
          this.ListRamzKasrAghsat[number].length < 1)
      ) {
        this.$mySweetDefault(
          "خطا",
          "کد کسر اقساط ضامن را وارد نکرده اید",
          "error",
          2000,
        );
        return;
      } else if (
        this.$session.get("CustCode") == 932 &&
        (this.ListRamzKasrAghsat[number] == undefined ||
          this.ListRamzKasrAghsat[number].length != 13)
      ) {
        this.$mySweetDefault(
          "خطا",
          "کد کسر اقساط ضامن 13 رقمی می باشد",
          "error",
          2000,
        );
        return;
      }
      if (this.ListCodeMeli[number].length < 10) {
        this.$mySweetDefault(
          "خطا",
          " طول کد ملی نمیتواند کمتر از 10 رقم باشد",
          "error",
          2000,
        );
      } else {
        var DataAxiosGetZament = {
          ArryfildValue: "",
          Method: "Post",
          Action: "GetZamenByMelli3Onlione",
          Token: this.$session.get("TokenNetPa"),
        };
        var formdata = new FormData();
        formdata.append(
          "wwwtblShobeId",
          this.$session.get("UserInfoNetPa").wwwtblShobeId,
        );
        formdata.append("CodeMeli", this.ListCodeMeli[number]);
        DataAxiosGetZament.ArryfildValue = formdata;
        this.$PostFormData(DataAxiosGetZament).then((data) => {
          if (data != null) {
            if (data.success && data.success == "Failed") {
              if (this.ListNoePolicyFilter.isOzv == true) {
                //وقتی که عضویت ضامن اجباری باشد
                this.$mySweetDefault("خطا", data.message, "error", 3500);
              } else {
                this.$mySweetDefaultTost(
                  "عدم وجود عضو",
                  "کد ملی وارد شده یافت نشد لطفا اطلاعات ضامن خود را وارد نمایید",
                  "warning",
                  1500,
                );
                //باز شدن مدال و گرفتن اطلاعات ضامن
                document.getElementById("openModal").click();
                this.ZamenToInsert["CodeMeli"] = this.ListCodeMeli[number];
                if (this.$session.get("CustCode") == 932) {
                  this.ZamenToInsert["RamzKasrAghsatZamen"] =
                    this.ListRamzKasrAghsat[number];
                }
              }
              // console.log(this.ListNoePolicyFilter)
            } else if (data.mandeZemanat != null) {
              console.log("*/*//*/*", data);

              if (
                data.mandeZemanat >=
                  Number(this.vamDetail.MablaghVam.replace(/\,/g, "")) ||
                data.mandeZemanat == 0
              ) {
                //مبلغ وام کمتر از سقف ضمانت می باشد
                if (this.ListZamen.length == 0) {
                  if (this.ListNoePolicyFilter.maxCountForZemanat == -1) {
                    // تعداد ضمانت فرد ثابل قبول می باشد
                    this.ListZamen.push({
                      Tel: data.tel,
                      Pedar: data.pedar,
                      NameFamily: data.nameFamily,
                      Mobile: data.mobile,
                      Adres: data.adres,
                      Id: data.id,
                      CodeMeli: this.ListCodeMeli[number],
                      RamzKasrAghsatZamen: this.ListRamzKasrAghsat[number],
                    });
                    return;
                  } else {
                    if (
                      data.countZemanat <
                        this.ListNoePolicyFilter.maxCountForZemanat ||
                      (data.countZemanat == 0 &&
                        this.ListNoePolicyFilter.maxCountForZemanat == 0)
                    ) {
                      this.ListZamen.push({
                        Tel: data.tel,
                        Pedar: data.pedar,
                        NameFamily: data.nameFamily,
                        Mobile: data.mobile,
                        Adres: data.adres,
                        Id: data.id,
                        CodeMeli: this.ListCodeMeli[number],
                        RamzKasrAghsatZamen: this.ListRamzKasrAghsat[number],
                      });
                      return;
                    } else {
                      this.$mySweetDefaultTost(
                        "هشدار",
                        "ضامن وارد شده به سقف تعداد ضمانت رسیده ، لطفا ضامن دیگری انتحاب نمایید",
                        "warning",
                        2000,
                      );
                      this.ListRamzKasrAghsat[number] = "";
                      return;
                    }
                  }
                } else {
                  for (let index = 0; index < this.ListZamen.length; index++) {
                    if (
                      this.ListZamen[index].CodeMeli ==
                      this.ListCodeMeli[number]
                    ) {
                      this.$mySweetDefault(
                        "هشدار",
                        "ضامن تکراری است",
                        "warning",
                        2000,
                      );
                      return;
                    } else {
                      if (this.ListNoePolicyFilter.maxCountForZemanat == -1) {
                        this.ListZamen.push({
                          Tel: data.tel,
                          Pedar: data.pedar,
                          NameFamily: data.nameFamily,
                          Mobile: data.mobile,
                          Adres: data.adres,
                          Id: data.id,
                          CodeMeli: this.ListCodeMeli[number],
                          RamzKasrAghsatZamen: this.ListRamzKasrAghsat[number],
                        });
                        return;
                      } else {
                        if (
                          data.countZemanat <
                            this.ListNoePolicyFilter.maxCountForZemanat ||
                          (data.countZemanat == 0 &&
                            this.ListNoePolicyFilter.maxCountForZemanat == 0)
                        ) {
                          this.ListZamen.push({
                            Tel: data.tel,
                            Pedar: data.pedar,
                            NameFamily: data.nameFamily,
                            Mobile: data.mobile,
                            Adres: data.adres,
                            Id: data.id,
                            CodeMeli: this.ListCodeMeli[number],
                            RamzKasrAghsatZamen:
                              this.ListRamzKasrAghsat[number],
                          });
                          return;
                        } else {
                          this.$mySweetDefaultTost(
                            "هشدار",
                            "ضامن وارد شده به سقف تعداد ضمانت خود رسیده ، لطفا ضامن دیگری انتحاب نمایید",
                            "warning",
                            2000,
                          );
                          return;
                        }
                      }
                    }
                  }
                }
              } else {
                this.$mySweetDefault(
                  "خطا",
                  "ضامن وارد شده به سقف مبلغ ضمانت و یا سقف تعداد ضمانت خود رسیده ، لطفا ضامن دیگری انتخاب نمایید",
                  "error",
                  3500,
                );
              }
            } else {
              this.$mySweetDefault(
                "خطا",
                "خطایی در محاسبه مانده ضمانت ضامن رخ داده ",
                "error",
                3500,
              );
            }
          }
        });
      }
    },
    handleMablagh(event) {
      const inputValue = Number(
        event.target.value.replace(/,/g, "").replace(/\./g, ""),
      );
      if (inputValue == NaN) {
        this.$mySweetDefault(
          "هشدار",
          "مقدار مبلغ درخواستی معتبر نمیباشد",
          "warning",
          3000,
        );
        this.isValidMablaghVam = "false";
        return false;
      }

      if (
        inputValue < Number(this.SelectedVam.minMablagh) &&
        Number(this.SelectedVam.minMablagh) > 0
      ) {
        this.$mySweetDefault(
          "هشدار",
          "مقدار حداقل مبلغ درخواستی رعایت نشده است",
          "warning",
          3000,
        );
        this.isValidMablaghVam = false;
        return false;
      }
      let mab =
        this.$session.get("CustCode") == "932"
          ? Math.round(Number(this.SelectedVam.maxMablagh))
          : Number(this.SelectedVam.maxMablagh);
      if (inputValue > mab && Number(this.SelectedVam.maxMablagh) > 0) {
        this.$mySweetDefault(
          "هشدار",
          "مقدار حداکثر مبلغ درخواستی رعایت نشده است",
          "warning",
          3000,
        );
        this.isValidMablaghVam = false;
        return false;
      } else this.isValidMablaghVam = true;
    },
    handleTedad(event) {
      const inputValue = Number(event.target.value);

      if (
        inputValue < Number(this.SelectedVam.minTedad) &&
        Number(this.SelectedVam.minTedad) > 0
      ) {
        this.$mySweetDefault(
          "هشدار",
          "مقدار حداقل تعداد قسط درخواستی رعایت نشده است",
          "warning",
          3000,
        );
        this.isValidTedad = false;
        return false;
      }

      if (
        inputValue > Number(this.SelectedVam.maxTedad) &&
        Number(this.SelectedVam.maxTedad) > 0
      ) {
        this.$mySweetDefault(
          "هشدار",
          "مقدار حداکثر تعداد قسط درخواستی رعایت نشده است",
          "warning",
          3000,
        );
        this.isValidTedad = false;
        return false;
      } else this.isValidTedad = true;
    },
    calculateMablaghghest(e) {
      if (
        this.SelectedVam.isformula &&
        (this.$session.get("CustCode") == 868 ||
          this.$session.get("CustCode") == 920 ||
          this.$session.get("CustCode") == 932)
      ) {
        var formdata = new FormData();
        formdata.append("wwwtblNoeId", this.SelectedVam.id);
        formdata.append(
          "MabDarkhastVam",
          Number(this.vamDetail.MablaghVam.replace(/,/g, "")),
        );
        formdata.append("TedadGhest", this.vamDetail.TedadGhest);
        formdata.append("TarixDarkhast", this.vamDetail.NeedData);
        var DataAxios = {
          ArryfildValue: formdata,
          Method: "Post",
          Action: "InsNewVam/CalcKarmozd",
          Token: this.$session.get("TokenNetPa"),
        };
        this.$PostFormData(DataAxios).then((res) => {
          this.vamDetail.Mablaghghest =
            (res.data[0].karmozdBimeSood +
              Number(this.vamDetail.MablaghVam.replace(/,/g, ""))) /
            this.vamDetail.TedadGhest;
          this.vamDetail.Mablaghghest = Math.round(this.vamDetail.Mablaghghest);
          this.vamDetail.Mablaghghest = this.vamDetail.Mablaghghest + "";
          this.vamDetail.Mablaghghest =
            this.$session.get("CustCode") == 868
              ? this.$Comma3ragham(
                  Number(this.vamDetail.Mablaghghest.replace(/\d{4}$/, "0000")),
                )
              : this.$Comma3ragham(Number(this.vamDetail.Mablaghghest));
        });
      } else {
        if (this.SelectedVam.TedadGhest == 0) {
          this.vamDetail.Mablaghghest = 0;
        } else {
          this.vamDetail.Mablaghghest =
            Number(this.vamDetail.MablaghVam.replaceAll(/,/g, "")) > 0
              ? this.$Comma3ragham(
                  Math.round(
                    Number(this.vamDetail.MablaghVam.replaceAll(/,/g, "")) /
                      this.vamDetail.TedadGhest,
                  ),
                )
              : 0;
        }
      }
    },
    selectCurent(data, number) {
      var headers = document.getElementsByClassName("hoverHeader");
      for (let index = 0; index < headers.length; index++) {
        const element = headers[index];
        element.classList.remove("current");
      }
      if (data.target) {
        data.target.parentNode.classList.add("current");
      } else {
        data.parentNode.classList.add("current");
      }
      this.divToShow = number;
    },
    nextPage(number) {
      window.scrollTo({
        top: 0,
        // behavior: 'smooth' // این باعث میشه نرمه بره بالا
      });
      this.calculateMablaghghest();
      if (number == 2) {
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formData.append("wwwtblSarfaslTypeId", 2);
        this.DataAxiosTaahodat.ArryfildValue = formData;
        this.$PostFormData(this.DataAxiosTaahodat).then((data) => {
          this.ListTaahodat = data;
        });

        this.DataAxiosAzaHesab.ArryfildValue = {
          Id: this.$session.get("UserInfoNetPa").wwwtblAzaId,
        };
        this.$GetData_Header(this.DataAxiosAzaHesab).then((data) => {
          this.ListAzaHesab = data;
        });
      }
      if (number == 3) {
        if (
          this.$session.get("CustCode") == "932" &&
          this.SelectedVam.bnpCashDBtblNoeId == 2698162 &&
          (this.vamDetail.SepordeTime == 0 ||
            this.vamDetail.SepordeTime == null)
        ) {
          this.$mySweetDefault(
            "عدم ورود مدت سپرده",
            "لطفا مدت سپرده خودرا وارد کنید ",
            "warning",
            2000,
          );
          return;
        }
        if (this.isValidTedad == false || this.isValidMablaghVam == false) {
          return;
        }
        if (
          !this.tblMavaredMasrafiVamId > 0 &&
          this.$session.get("CustCode") == 793
        ) {
          this.$mySweetDefault(
            "عدم ورود مورد مصرف وام",
            "لطفا مورد مصرف وام خود را وارد کنید ",
            "warning",
            2000,
          );
          return;
        }
      }
      if (number == 4) {
        if (this.ListNoePolicyFilter.tedad != undefined) {
          if (this.ListZamen.length != this.ListNoePolicyFilter.tedad) {
            this.$mySweetDefaultTost(
              "عدم تکمیل ضامنین",
              "اطلاعات هر " +
                this.ListNoePolicyFilter.tedad +
                " ضامن باید تکمیل شوند",
              "warning",
              1500,
            );
            return;
          }
        }
      }
      if (number == 5) {
        if (this.$session.get("CustCode") == "932") {
          if (this.codeKasrAghsat != null && this.codeKasrAghsat.length == 13) {
            this.selectCurent(document.getElementById("head" + number), number);
          } else if (
            this.codeKasrAghsat == null ||
            this.codeKasrAghsat.length == 0
          ) {
            this.$mySweetDefault(
              "خطا",
              "کد کسر اقساط خودرا وارد کنید ",
              "error",
              2000,
            );
            return;
          } else {
            this.$mySweetDefault(
              "خطا",
              "کد کسر اقساط باید 13 رقمی باشد",
              "error",
              2000,
            );
            return;
          }
        }
      }
      this.selectCurent(document.getElementById("head" + number), number);
    },
    GetNoeVam() {
      var formdata = new FormData();
      this.$PostFormData(this.DataAxiosGetNoeVam).then((data) => {
        this.Vamha = data;
      });
    },
    UpdateZamenPolicy() {
      this.ListNoePolicyFilter = [];
      if (this.ListNoePolicy != null) {
        for (let index = 0; index < this.ListNoePolicy.length; index++) {
          //console.log("*/*/",this.vamDetail.MablaghVam.replace(/,/g, "").replace(/\./g, ""),);
          if (
            Number(
              this.vamDetail.MablaghVam.replace(/,/g, "").replace(/\./g, ""),
            ) >= this.ListNoePolicy[index].mabAz &&
            Number(
              this.vamDetail.MablaghVam.replace(/,/g, "").replace(/\./g, ""),
            ) <= this.ListNoePolicy[index].mabTa
          ) {
            // console.log('*/*/',Number(this.vamDetail.MablaghVam.replace(/,/g, '').replace(/\./g, '')));
            // console.log('*----',this.ListNoePolicy[index]);
            this.ListNoePolicyFilter = [];
            this.ListNoePolicyFilter = this.ListNoePolicy[index];
          }
        }
      }

      // console.log(this.ListNoePolicyFilter);
    },
    seLectVam(item) {
      let error = false;
      (this.ListCodeMeli = []),
        (this.ListZamen = []),
        (this.attachment = null),
        (this.ListTaahodat = []),
        (this.ListAzaHesab = []),
        (this.ListNoePolicy = null),
        (this.ListNoePolicyFilter = null),
        (this.lines = []),
        (this.linesattachment = []);
      if (
        item.equal != null &&
        item.equal > 0 &&
        item.tblNoeIdEqual != null &&
        item.tblNoeIdEqual != -1 &&
        (item.equalMin == null || item.equalMin == 0) &&
        (item.equalMax == null || item.equalMax == 0)
      ) {
        // برای این نوع وام شرط چند برابری تعریف شده
        // برای 932 تامین اجتماعی
        this.VamChechUpNoeEquals(item)
          .then((result) => {
            item.maxMablagh = result;
            if (item.minMablagh > result) {
              // درحالت فرمولی نباید مبلغ ابتدا بزرگتر از انتها باشد

              error = true;
              this.$mySweetDefault(
                "هشدار",
                "موجودی حساب شما از حداقل مبلغ درخواستی این نوع وام کمتر می باشد",
                "warning",
                3000,
              );
              return;
            }
          })
          .catch((err) => {
            this.$mySweetDefault("هشدار", err.msg, "warning", 3000);
            error = true;
            return;
          });
      }
      if (
        item.equalMin != null &&
        item.equalMin > 0 &&
        item.tblNoeIdEqualListMin != null &&
        item.tblNoeIdEqualListMin != ""
      ) {
        this.VamChechUpNoeEqualsList(item.equalMin, item.tblNoeIdEqualListMin)
          .then((res) => {
            item.minMablagh = res;
            if (res > item.maxMablagh && item.maxMablagh != 0) {
              // درحالت فرمولی نباید مبلغ ابتدا بزرگتر از انتها باشد
              item.minMablagh = item.maxMablagh;
            }
          })
          .catch((err) => {
            this.$mySweetDefault("هشدار", err.msg, "warning", 3000);
            error = true;
            return;
          });
      }
      if (
        item.equalMax != null &&
        item.equalMax > 0 &&
        item.tblNoeIdEqualListMax != null &&
        item.tblNoeIdEqualListMax != ""
      ) {
        this.VamChechUpNoeEqualsList(item.equalMax, item.tblNoeIdEqualListMax)
          .then((res) => {
            item.maxMablagh = res;
            if (item.minMablagh > res) {
              // درحالت فرمولی نباید مبلغ ابتدا بزرگتر از انتها باشد
              item.minMablagh = res;
            }
          })
          .catch((err) => {
            this.$mySweetDefault("هشدار", err.msg, "warning", 3000);
            error = true;
            return;
          });
      }
      if (item.equalHoghogh != null && item.equalHoghogh > 0) {
        this.VamChechUpNoeEqualHoghogh(item.equalHoghogh).then((res) => {
          if (res == 0) {
            item.maxMablagh = 0;
            item.minMablagh = 0;
          } else {
            item.maxMablagh = res;
            if (item.minMablagh > res) {
              // درحالت فرمولی نباید مبلغ ابتدا بزرگتر از انتها باشد
              item.minMablagh = res;
            }
          }
        });
      }

      this.FixInputMabVam = item.isFixInputMablaghVam;

      var formdata = new FormData();
      formdata.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formdata.append("wwwtblNoeId", item.id);
      formdata.append("CustCode", this.$session.get("CustCode"));
      formdata.append("MablaghEftetahHesab", this.$GetMablaghEftetahHesab());

      this.DataActionVamCondition.ArryfildValue = formdata;
      console.log(
        "wwwtblAzaId:",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      console.log("wwwtblNoeId:", item.id);
      this.$PostFormData(this.DataActionVamCondition)
        .then((res) => {
          console.log(res);
          switch (res.id) {
            case 0:
              error == false ? (this.SelectedVam = item) : false;

              this.vamDetail.Mablaghghest =
                this.SelectedVam.minTedad > 0 && this.SelectedVam.minMablagh > 0
                  ? this.$Comma3ragham(
                      Math.floor(
                        this.SelectedVam.minMablagh / this.SelectedVam.minTedad,
                      ),
                    )
                  : 0;
              this.vamDetail.MablaghVam =
                this.$session.get("CustCode") == "932"
                  ? this.$Comma3ragham(Math.round(this.SelectedVam.maxMablagh))
                  : this.SelectedVam.minMablagh > 0
                  ? this.$Comma3ragham(this.SelectedVam.minMablagh)
                  : "0";
              this.vamDetail.TedadGhest =
                this.$session.get("CustCode") == "932"
                  ? this.SelectedVam.maxTedad
                  : this.SelectedVam.minTedad;
              this.isValidTedad = true;
              this.isValidMablaghVam = true;
              this.lines =
                this.SelectedVam.des != ""
                  ? this.SelectedVam.des.split("\n")
                  : null;
              this.linesattachment =
                this.SelectedVam.desUpload != ""
                  ? this.SelectedVam.desUpload.split("\n")
                  : null;

              var formdata = new FormData();
              formdata.append("id", this.SelectedVam.settingId);
              this.DataAxiosZamenPolicy.ArryfildValue = formdata;
              this.$PostFormData(this.DataAxiosZamenPolicy)
                .then((res) => {
                  var formdata1 = new FormData();
                  formdata1.append(
                    "wwwtblAzaId",
                    this.$session.get("UserInfoNetPa").wwwtblAzaId,
                  );
                  let GetTafsilyType932 = {
                    ArryfildValue: "",
                    Method: "Post",
                    Action: "RequestVamNew/VamChechTafsilyType932",
                    Token: this.$session.get("TokenNetPa"),
                  };
                  GetTafsilyType932.ArryfildValue = formdata1;
                  this.$PostFormData(GetTafsilyType932).then((data) => {
                    if (
                      data == 293441 &&
                      this.$session.get("CustCode") == "932"
                    ) {
                      this.ListNoePolicy = [];
                      // console.log(this.ListNoePolicy);
                    } else {
                      this.ListNoePolicy = res;
                    }
                    this.UpdateZamenPolicy();
                  });
                })
                .finally(() => {});
              break;
            case 1:
              this.$mySweetDefault(
                "هشدار",
                "سابقه عضویت شما جهت درخواست وام کافی نمیباشد.",
                "warning",
                3000,
              );
              break;
            case 2:
              this.$mySweetDefault(
                "هشدار",
                "سقف بودجه ماهیانه به اتمام رسیده است.",
                "warning",
                3000,
              );
              break;
            case 3:
              this.$mySweetDefault(
                "هشدار",
                "موجودی حساب شما جهت درخواست وام کمتر از سقف تایید شده میباشد.",
                "warning",
                3000,
              );
              break;
            case 4:
              this.$mySweetDefault(
                "هشدار",
                "به علت عدم رعایت سقف بدهی قبلی از این نوع وام شما مجاز به ثبت درخواست نمیباشید.",
                "warning",
                3000,
              );
              break;
            case 5:
              this.$mySweetDefault(
                "هشدار",
                "به علت عدم رعایت محدوده روز درخواست مجاز به ثبت درخواست نمیباشید.",
                "warning",
                3000,
              );
              break;
            case 6:
              this.$mySweetDefault(
                "هشدار",
                "این تسهیلات پیش از این توسط شما درخواست داده شده است.",
                "warning",
                2000,
              );
              break;
            case 7:
              this.$mySweetDefault(
                "هشدار",
                "به علت بدهی در دیگر وام ها امکان درخواست نمی باشد",
                "warning",
                2000,
              );
              break;
            case 8:
              this.$mySweetDefault(
                "هشدار",
                "برای درخواست این نوع واع باید مبلغ افتتاح حساب واریز شده باشد",
                "warning",
                2000,
              );
              break;
            case 9:
              this.$mySweetDefault(
                "هشدار",
                "برای درخواست این وام باید از افتتاح حساب شما حداقل " +
                  item.minMahAzEftetahHesab +
                  " ماه گذشته باشد",
                "warning",
                2000,
              );
              break;
            case 10:
              this.$mySweetDefault(
                "هشدار",
                "برای درخواست این نوع وام تعداد اقساط باقی مانده وام قبلی شما بیشتر از حد تعیین شده می باشد",
                "warning",
                3000,
              );
              break;
            case 11:
              this.$mySweetDefault(
                "هشدار",
                "برای درخواست این نوع وام  باید وام های قبلی شما تسویه شده باشد",
                "warning",
                3000,
              );
              break;
            case 12:
              this.$mySweetDefault(
                "هشدار",
                "برای درخواست این نوع وام باید حداقل مدتی از زمان تسویه آخرین وام شما گذشته باشد",
                "warning",
                3000,
              );
              break;
            case 13:
              this.$mySweetDefault(
                "هشدار",
                "برای درخواست این نوع وام باید حداقل مدتی از تاریخ افتتاح حساب شما گذشته باشد",
                "warning",
                3000,
              );
              break;
            case 14:
              this.$mySweetDefault(
                "هشدار",
                "برای درخواست این نوع وام باید حداقل " +
                  item.minDarsadAzTasvieHaminNoe +
                  " درصد از تاریخ دریافت وام های شما گذشته باشد",
                "warning",
                3000,
              );
              break;
            case 15:
              this.$mySweetDefault(
                "هشدار",
                "به علت داشتن درخواست تسهیلات باز از این نوع وام و یا وام های دیگر امکان درخواست از این نوع وام امکان پذیر نمی باشد",
                "warning",
                3000,
              );
              break;
            default:
              this.$mySweetDefault(
                "خطا",
                "پاسخی از سرور دریافت نشد.",
                "error",
                2000,
              );
              break;
          }
        })
        .finally(() => {});
      //this.SelectedVam=item
    },
    clickUploader() {
      document.getElementById("attachmentUploader").click();
    },
    changeattach(e) {
      const file = e.target.files[0];
      if (!file) return;

      const allowedExtensions = [
        "gif",
        "jpg",
        "jpeg",
        "png",
        "zip",
        "rar",
        "pdf",
      ];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        this.$mySweetDefaultTost(
          "فرمت فایل مجاز نیست",
          `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
          "error",
          3000,
        );
        e.target.value = "";
        return;
      }
      if (
        this.$session.get("CustCode") == "8002" ||
        this.$session.get("CustCode") == "932"
      ) {
        this.zip().then((zipfile) => {
          this.attachment = this.base64;
        });
      } else {
        this.attachment =
          document.getElementById("attachmentUploader").files[0];
        if (this.attachment.size / 1000000 > 5) {
          this.$mySweetDefaultTost(
            "هشدار",
            "حجم فایل نمیتواند بیش از 5 مگابایت باشد",
            "error",
            3000,
          );
          document.getElementById("attachmentUploader").value = null;
          this.attachment = null;
        }
      }
    },
    VamChechUpNoeEquals(item) {
      return new Promise((success, error) => {
        var formdata = new FormData();
        formdata.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formdata.append("Equal", item.equal + "");
        formdata.append("wwwtblNoeIdEqual", item.tblNoeIdEqual);
        let DataAxiosChechUp = {
          ArryfildValue: "",
          Method: "Post",
          Action: "RequestVamNew/VamChechUpNoeEquals",
          Token: this.$session.get("TokenNetPa"),
        };
        DataAxiosChechUp.ArryfildValue = formdata;
        this.$PostFormData(DataAxiosChechUp).then((res) => {
          if (res.status == "faild") {
            error(res);
          }
          success(res);
        });
      });
    },
    VamChechUpNoeEqualsList(Eq, ListE) {
      return new Promise((success, error) => {
        var formdata = new FormData();
        formdata.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formdata.append("Equal", Eq);
        formdata.append("wwwtblNoeIdEqualList", ListE);
        let DataAxiosChechUp = {
          ArryfildValue: "",
          Method: "Post",
          Action: "RequestVamNew/VamChechUpNoeEqualsList",
          Token: this.$session.get("TokenNetPa"),
        };
        DataAxiosChechUp.ArryfildValue = formdata;
        this.$PostFormData(DataAxiosChechUp).then((res) => {
          if (res.status == "faild") {
            error(res);
          }
          success(res);
        });
      });
    },
    VamChechUpNoeEqualHoghogh(EqHoghogh) {
      return new Promise((success, error) => {
        var formdata = new FormData();
        formdata.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formdata.append("EqualHoghogh", EqHoghogh);
        let DataAxiosChechUp = {
          ArryfildValue: "",
          Method: "Post",
          Action: "RequestVamNew/VamChechUpNoeEqualHoghogh",
          Token: this.$session.get("TokenNetPa"),
        };
        DataAxiosChechUp.ArryfildValue = formdata;
        this.$PostFormData(DataAxiosChechUp).then((res) => {
          success(res);
        });
      });
    },
    changefile(e) {
      const file = e.target.files[0];
      if (!file) return;

      const allowedExtensions = [
        "gif",
        "jpg",
        "jpeg",
        "png",
        "zip",
        "rar",
        "pdf",
      ];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        this.$mySweetDefaultTost(
          "فرمت فایل مجاز نیست",
          `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
          "error",
          3000,
        );
        e.target.value = "";
        return;
      }
      if (document.getElementById("Uploader").files[0].size > 1024 * 1024 * 1) {
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          "  حجم فایل مورد نظر بیشتر از 1 مگابایت است ",
          "error",
          3000,
        );
        return;
      }
      this.fileinfo = document.getElementById("Uploader").files[0];
    },
    clickUploaderZamen() {
      document.getElementById("Uploader").click();
    },
    NewZamen() {
      if (!this.$ValidForm("NewZamenForm")) {
        return;
      }
      if (this.ZamenToInsert.NameFamily.trim() == "") {
        this.$mySweetDefaultTost(
          "خطا",
          "نام و نام خانوادگی الزامی می باشد",
          "error",
          2000,
        );
        this.ZamenToInsert = {};
        return;
      }
      if (this.ZamenToInsert.PerNo == "" || this.ZamenToInsert.PerNo == null) {
        this.$mySweetDefaultTost(
          "خطا",
          "کد پرسنلی الزامی می باشد ",
          "error",
          2000,
        );
        this.ZamenToInsert = {};
        return;
      }
      if (
        this.ZamenToInsert.Mobile == "" ||
        this.ZamenToInsert.Mobile == null ||
        this.ZamenToInsert.Mobile.length < 11
      ) {
        this.$mySweetDefaultTost(
          "خطا",
          "شماره موبایل به  درستی وارد نشده",
          "error",
          2000,
        );
        this.ZamenToInsert = {};
        return;
      }
      if (
        this.$session.get("CustCode") == "932" ||
        this.$session.get("CustCode") == "8002"
      ) {
        this.ZamenToInsert["Tel"] = "";
        this.ZamenToInsert["Pedar"] = "";
        this.ZamenToInsert["Adres"] = "";
        this.ZamenToInsert["file"] = this.fileinfo;
      }

      this.ListZamenToInsert.push(this.ZamenToInsert);
      this.ListZamen.push(this.ZamenToInsert);

      this.ZamenToInsert = {};
      this.fileinfo = {};
      var genericModalEl = document.getElementById("BtnCloseModal");
      genericModalEl.click();
    },
    // async zip(listFile) {
    //   listFile.forEach(element => {
    //     if ((element.size / 1000000 > 5)){
    //       this.$mySweetDefaultTost('هشدار', 'حجم یکی از فایل ها بیشتر از 5 مگابایت میباشد', 'error', 3000)
    //       return;
    //     }
    //   });
    //   let filedata
    //   let base64
    //   let isImage
    //   let fileFormat
    //   let zip = new JSZip()
    //   console.log(document.getElementById('attachmentUploader').files);
    //   listFile.forEach(element => {
    //     console.log(element);
    //     zip.file(element.name, element)
    //   });
    //   await zip
    //     .generateAsync({ type: 'base64' })
    //     .then(function (Convertbase64) {
    //       filedata = 'data:application/zip;base64,' + Convertbase64
    //     })
    //     .finally(() => {
    //       base64 = filedata
    //       base64 = base64.split(',')[1]
    //       isImage = false
    //       fileFormat = 'zip'
    //     })
    //   // this.File = 'data:application/zip;base64,' + base64
    //   this.FileZip = base64
    //   return base64
    // }
    async zip() {
      var input = document.getElementById("attachmentUploader");

      let filedata = null;
      let zip = new JSZip();
      this.imageSize = 0;
      this.uploadImageName = "";
      for (let index = 0; index < input.files.length; index++) {
        let lengthSplit = input.files[index].name.split(".").length;
        var Checktypes =
          "." +
          input.files[index].name.split(".")[lengthSplit - 1].toLowerCase();
        this.imageSize += input.files[index].size;
        this.uploadImageName += input.files[index].name + " , ";
        const element = input.files[index];
        let filename = input.files[index].name;
        var folderName = this.$store.state.JalaliDate;
        folderName = folderName.replaceAll("/", "_");
        zip.file(folderName + "/" + filename, element);
      }
      this.imageSize = Math.round(this.imageSize / 1000);
      if (this.imageSize < 10010) {
        await zip
          .generateAsync({ type: "base64" })
          .then(function (Convertbase64) {
            filedata = "data:application/zip;base64," + Convertbase64;
          })
          .finally(() => {
            this.base64 = filedata;
            this.base64 = this.base64.split(",")[1];
            this.fileFormat = "zip";
          });
        return this.base64;
      } else {
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          "مجموع حجم فایل ها باید کمتر از 10 مگابایت باشد",
          "info",
          3000,
        );
        this.cancelUpload();
      }
    },
    cancelUpload() {
      this.base64 = null;
      this.uploadImageName = "";
      this.imageSize = 0;
      var input = document.getElementById("inputImage");
      input.value = "";
      this.fileFormat = "";
      this.isImage = null;
    },
    GetMavaredMasrafi() {
      var formdata = new FormData();
      var DataAxiosSubmit = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "InsNewVam/GetMavaredMasrafVam",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxiosSubmit).then((res) => {
        if (res.state == true) {
          this.ListMavaredMasrafVam = res.data;
          this.tblMavaredMasrafiVamId = res.data[0].id;
        } else {
          this.ListMavaredMasrafVam = [];
        }
      });
    },
  },
};
</script>
<style scoped>
.hoverHeader:hover {
  font-weight: bold;
  color: darkorchid;
  background: rgb(224, 221, 226);
  cursor: pointer;
  transition: all 0.5s ease-in;
}
/* .hoverHeader{
    border-radius: 11% 89% 12% 88% / 94% 0% 100% 6%  ;
    -webkit-box-shadow: 0px 0px 15px -6px rgba(202,202,202,0.72); 
    box-shadow: 0px 0px 15px -6px rgba(202,202,202,0.72);

} */
.hoverHeader.current {
  font-weight: bold;
  color: #435ebe;
  background: #dee3f5;
  cursor: pointer;
  transition: all 0.5s ease-in;
}

.blueback {
  width: 100%;
  min-height: 80px;
  background: rgb(184, 218, 235);
  border: 2px dotted #3161e7;
  border-radius: 15px;
}

.yellowback {
  width: 100%;
  min-height: 80px;
  background: rgb(208, 224, 118);
  border: 2px dotted #929c04;
  border-radius: 15px;
}

.Uploader {
  width: 100%;
  height: 100%;
  border: 2px dashed #0c6ec9 !important;
  border-radius: 8px;
}
.Uploader:hover .fa-file-import {
  color: #0c6ec9 !important;
  transition: 0.3s;
}
</style>
